[
  { "unitKey": "g", "translated": true,
    "values": {
      "en": { "unitName": "g", "eq": ["g", "gram", "grams", "gr", "gramme"] },
      "fr": { "unitName": "g", "eq": ["g", "gramme", "grammes", "gr"] },
      "de": { "unitName": "g", "eq": ["g", "Gramm", "gr"] },
      "es": { "unitName": "g", "eq": ["g", "gramo", "gramos", "gr"] },
      "it": { "unitName": "g", "eq": ["g", "grammo", "grammi", "gr"] },
      "nl": { "unitName": "g", "eq": ["g", "gram", "gr"] }
    } },

  { "unitKey": "kg", "translated": true,
    "values": {
      "en": { "unitName": "kg", "eq": ["kg", "kilogram", "kilograms", "kilo"] },
      "fr": { "unitName": "kg", "eq": ["kg", "kilogramme", "kilogrammes", "kilo"] },
      "de": { "unitName": "kg", "eq": ["kg", "Kilogramm"] },
      "es": { "unitName": "kg", "eq": ["kg", "kilogramo", "kilogramos", "kilos"] },
      "it": { "unitName": "kg", "eq": ["kg", "chilogrammo", "chilogrammi"] },
      "nl": { "unitName": "kg", "eq": ["kg", "kilogram"] }
    } },

  { "unitKey": "mg", "translated": true,
    "values": {
      "en": { "unitName": "mg", "eq": ["mg", "milligram", "milligrams"] },
      "fr": { "unitName": "mg", "eq": ["mg", "milligramme", "milligrammes"] },
      "de": { "unitName": "mg", "eq": ["mg", "Milligramm"] },
      "es": { "unitName": "mg", "eq": ["mg", "miligramo", "miligramos"] },
      "it": { "unitName": "mg", "eq": ["mg", "milligrammo", "milligrammi"] },
      "nl": { "unitName": "mg", "eq": ["mg", "milligram"] }
    } },

  { "unitKey": "ml", "translated": true,
    "values": {
      "en": { "unitName": "ml", "eq": ["ml", "mL", "milliliter", "milliliters"] },
      "fr": { "unitName": "ml", "eq": ["ml", "millilitre", "millilitres"] },
      "de": { "unitName": "ml", "eq": ["ml", "Milliliter"] },
      "es": { "unitName": "ml", "eq": ["ml", "mililitro", "mililitros"] },
      "it": { "unitName": "ml", "eq": ["ml", "millilitro", "millilitri"] },
      "nl": { "unitName": "ml", "eq": ["ml", "milliliter"] }
    } },

  { "unitKey": "cl", "translated": true,
    "values": {
      "en": { "unitName": "cl", "eq": ["cl", "centiliter", "centiliters"] },
      "fr": { "unitName": "cl", "eq": ["cl", "centilitre", "centilitres"] },
      "de": { "unitName": "cl", "eq": ["cl", "Zentiliter"] },
      "es": { "unitName": "cl", "eq": ["cl", "centilitro", "centilitros"] },
      "it": { "unitName": "cl", "eq": ["cl", "centilitro", "centilitri"] },
      "nl": { "unitName": "cl", "eq": ["cl", "centiliter"] }
    } },

  { "unitKey": "dl", "translated": true,
    "values": {
      "en": { "unitName": "dl", "eq": ["dl", "deciliter", "deciliters"] },
      "fr": { "unitName": "dl", "eq": ["dl", "décilitre", "décilitres"] },
      "de": { "unitName": "dl", "eq": ["dl", "Deziliter"] },
      "es": { "unitName": "dl", "eq": ["dl", "decilitro", "decilitros"] },
      "nl": { "unitName": "dl", "eq": ["dl", "deciliter"] },
      "sv": { "unitName": "dl", "eq": ["dl", "deciliter"] },
      "fi": { "unitName": "dl", "eq": ["dl", "desilitra"] }
    } },

  { "unitKey": "L", "translated": true,
    "values": {
      "en": { "unitName": "L", "eq": ["L", "l", "liter", "liters", "litre"] },
      "fr": { "unitName": "l", "eq": ["l", "litre", "litres"] },
      "de": { "unitName": "l", "eq": ["l", "Liter"] },
      "es": { "unitName": "l", "eq": ["l", "litro", "litros"] },
      "it": { "unitName": "l", "eq": ["l", "litro", "litri"] },
      "nl": { "unitName": "l", "eq": ["l", "liter"] }
    } },

  { "unitKey": "tbsp", "translated": true,
    "values": {
      "en": { "unitName": "tbsp", "eq": ["tbsp", "tbsp.", "tbs", "Tbsp", "T", "tblsp", "tblspn", "tablespoon", "tablespoons"] },
      "fr": { "unitName": "c. à s.", "eq": ["c. à s.", "cuillère à soupe", "cuillères à soupe", "càs", "c.à.s.", "c.s.", "cs", "cuil. à s.", "c. à soupe", "c.à soupe", "c à soupe", "c à s", "cuillère", "cuillères"] },
      "de": { "unitName": "EL", "eq": ["EL", "Esslöffel"] },
      "es": { "unitName": "cda.", "eq": ["cda.", "cda", "cdas", "cucharada", "cucharadas"] },
      "it": { "unitName": "cucchiaio", "eq": ["cucchiaio", "cucchiai"] },
      "nl": { "unitName": "el", "eq": ["el", "eetlepel", "eetlepels"] },
      "sv": { "unitName": "msk", "eq": ["msk", "matsked"] },
      "pt": { "unitName": "colher de sopa", "eq": ["colher de sopa", "colheres de sopa", "colheres"] }
    } },

  { "unitKey": "tsp", "translated": true,
    "values": {
      "en": { "unitName": "tsp", "eq": ["tsp", "tsp.", "teaspoon", "teaspoons"] },
      "fr": { "unitName": "c. à c.", "eq": ["c. à c.", "cuillère à café", "cuillères à café", "càc", "c.à.c.", "c.c.", "cc", "cuil. à c.", "c. à café", "c.à café", "c à café", "c à c", "c. à thé", "c.à thé", "c à thé"] },
      "de": { "unitName": "TL", "eq": ["TL", "Teelöffel"] },
      "es": { "unitName": "cdta.", "eq": ["cdta.", "cdta", "cdtas", "cucharadita", "cucharaditas"] },
      "it": { "unitName": "cucchiaino", "eq": ["cucchiaino", "cucchiaini"] },
      "nl": { "unitName": "tl", "eq": ["tl", "theelepel", "theelepels"] },
      "sv": { "unitName": "tsk", "eq": ["tsk", "tesked"] }
    } },

  { "unitKey": "cup", "translated": true,
    "values": {
      "en": { "unitName": "cup", "eq": ["cup", "cups", "c."] },
      "fr": { "unitName": "tasse", "eq": ["tasse", "tasses"] },
      "de": { "unitName": "Tasse", "eq": ["Tasse", "Tassen"] },
      "es": { "unitName": "taza", "eq": ["taza", "tazas"] },
      "nl": { "unitName": "kop", "eq": ["kop", "koppen", "koppie"] }
    } },

  { "unitKey": "oz", "translated": true,
    "values": {
      "en": { "unitName": "oz", "eq": ["oz", "oz.", "ounce", "ounces"] },
      "es": { "unitName": "oz", "eq": ["oz", "onza", "onzas"] }
    } },

  { "unitKey": "fl oz", "translated": true,
    "values": {
      "en": { "unitName": "fl oz", "eq": ["fl oz", "fl. oz.", "fluid ounce", "fluid ounces"] },
      "es": { "unitName": "fl oz", "eq": ["fl oz", "onza líquida", "onzas líquidas"] }
    } },

  { "unitKey": "lb", "translated": true,
    "values": {
      "en": { "unitName": "lb", "eq": ["lb", "lb.", "lbs", "pound", "pounds"] },
      "es": { "unitName": "lb", "eq": ["lb", "libra", "libras"] }
    } },

  { "unitKey": "pc", "translated": true,
    "values": {
      "en": { "unitName": "piece", "eq": ["piece", "pieces"] },
      "fr": { "unitName": "pièce", "eq": ["pièce", "pièces"] },
      "de": { "unitName": "Stück", "eq": ["Stück"] },
      "es": { "unitName": "unidad", "eq": ["unidad", "unidades", "ud", "uds"] },
      "it": { "unitName": "pezzo", "eq": ["pezzo", "pezzi"] },
      "nl": { "unitName": "stuk", "eq": ["stuk", "stuks"] }
    } },

  { "unitKey": "pack", "translated": false,
    "values": {
      "en": { "unitName": "pack", "eq": ["pack", "packs", "packet", "packets", "package"] },
      "fr": { "unitName": "paquet", "eq": ["paquet", "paquets"] },
      "de": { "unitName": "Packung", "eq": ["Packung", "Packungen", "Päckchen", "Pck.", "Paket"] },
      "es": { "unitName": "paquete", "eq": ["paquete", "paquetes"] },
      "nl": { "unitName": "pak", "eq": ["pak", "pakken", "pakje"] },
      "pt": { "unitName": "pacote", "eq": ["pacote", "pacotes", "sachê"] },
      "ro": { "unitName": "plic", "eq": ["plic", "plicuri"] }
    } },

  { "unitKey": "can", "translated": false,
    "values": {
      "en": { "unitName": "can", "eq": ["can", "cans", "tin", "tins"] },
      "fr": { "unitName": "boîte", "eq": ["boîte", "boîtes", "boite", "boites", "conserve", "conserves"] },
      "de": { "unitName": "Dose", "eq": ["Dose", "Dosen"] },
      "es": { "unitName": "lata", "eq": ["lata", "latas"] },
      "it": { "unitName": "lattina", "eq": ["lattina", "lattine"] },
      "nl": { "unitName": "blik", "eq": ["blik", "blikken", "blikje"] },
      "pt": { "unitName": "lata", "eq": ["lata", "latas"] }
    } },

  { "unitKey": "btl", "translated": false,
    "values": {
      "en": { "unitName": "bottle", "eq": ["bottle", "bottles"] },
      "fr": { "unitName": "bouteille", "eq": ["bouteille", "bouteilles"] },
      "de": { "unitName": "Flasche", "eq": ["Flasche", "Flaschen"] },
      "es": { "unitName": "botella", "eq": ["botella", "botellas"] },
      "nl": { "unitName": "fles", "eq": ["fles", "flessen"] }
    } },

  { "unitKey": "bag", "translated": false,
    "values": {
      "en": { "unitName": "bag", "eq": ["bag", "bags"] },
      "fr": { "unitName": "sachet", "eq": ["sachet", "sachets"] },
      "de": { "unitName": "Beutel", "eq": ["Beutel", "Tüte", "Tüten"] },
      "es": { "unitName": "bolsa", "eq": ["bolsa", "bolsas"] },
      "nl": { "unitName": "zak", "eq": ["zak", "zakken", "zakje"] }
    } },

  { "unitKey": "sl", "translated": false,
    "values": {
      "en": { "unitName": "slice", "eq": ["slice", "slices"] },
      "fr": { "unitName": "tranche", "eq": ["tranche", "tranches"] },
      "de": { "unitName": "Scheibe", "eq": ["Scheibe", "Scheiben"] },
      "es": { "unitName": "rodaja", "eq": ["rodaja", "rodajas", "loncha", "lonchas"] },
      "nl": { "unitName": "schijf", "eq": ["schijf", "schijven", "sneetje"] },
      "pt": { "unitName": "fatia", "eq": ["fatia", "fatias"] }
    } },

  { "unitKey": "bch", "translated": false,
    "values": {
      "en": { "unitName": "bunch", "eq": ["bunch", "bunches"] },
      "fr": { "unitName": "bouquet", "eq": ["bouquet", "bouquets", "botte", "bottes"] },
      "de": { "unitName": "Bund", "eq": ["Bund", "Bündel"] },
      "es": { "unitName": "manojo", "eq": ["manojo", "manojos"] },
      "nl": { "unitName": "bosje", "eq": ["bosje", "bosjes", "bussel"] },
      "sv": { "unitName": "knippe", "eq": ["knippe"] }
    } },

  { "unitKey": "box", "translated": false,
    "values": {
      "en": { "unitName": "box", "eq": ["box", "boxes"] },
      "fr": { "unitName": "carton", "eq": ["carton", "cartons"] },
      "de": { "unitName": "Schachtel", "eq": ["Schachtel", "Schachteln"] },
      "es": { "unitName": "caja", "eq": ["caja", "cajas"] },
      "nl": { "unitName": "doos", "eq": ["doos", "dozen"] }
    } },

  { "unitKey": "jar", "translated": false,
    "values": {
      "en": { "unitName": "jar", "eq": ["jar", "jars"] },
      "fr": { "unitName": "pot", "eq": ["pot", "pots"] },
      "de": { "unitName": "Glas", "eq": ["Glas", "Gläser"] },
      "es": { "unitName": "tarro", "eq": ["tarro", "tarros", "bote", "botes"] },
      "nl": { "unitName": "pot", "eq": ["pot", "potten", "potje"] },
      "pt": { "unitName": "pote", "eq": ["pote", "potes"] }
    } },

  { "unitKey": "pnch", "translated": false,
    "values": {
      "en": { "unitName": "pinch", "eq": ["pinch", "pinches"] },
      "fr": { "unitName": "pincée", "eq": ["pincée", "pincées"] },
      "de": { "unitName": "Prise", "eq": ["Prise", "Prisen"] },
      "es": { "unitName": "pizca", "eq": ["pizca", "pizcas"] },
      "it": { "unitName": "pizzico", "eq": ["pizzico", "pizzichi"] },
      "nl": { "unitName": "snufje", "eq": ["snufje", "knippie"] },
      "sv": { "unitName": "nypa", "eq": ["nypa", "krm"] }
    } },

  { "unitKey": "clv", "translated": false,
    "values": {
      "en": { "unitName": "clove", "eq": ["clove", "cloves"] },
      "fr": { "unitName": "gousse", "eq": ["gousse", "gousses"] },
      "de": { "unitName": "Zehe", "eq": ["Zehe", "Zehen", "Knoblauchzehe", "Knoblauchzehen"] },
      "es": { "unitName": "diente", "eq": ["diente", "dientes"] },
      "nl": { "unitName": "teentje", "eq": ["teentje", "teentjes"] },
      "sv": { "unitName": "klyfta", "eq": ["klyfta"] }
    } },

  { "unitKey": "sprg", "translated": false,
    "values": {
      "en": { "unitName": "sprig", "eq": ["sprig", "sprigs"] },
      "fr": { "unitName": "brin", "eq": ["brin", "brins", "branche", "branches", "tige", "tiges"] },
      "de": { "unitName": "Zweig", "eq": ["Zweig", "Zweige", "Stängel"] },
      "es": { "unitName": "ramita", "eq": ["ramita", "ramitas"] },
      "nl": { "unitName": "takje", "eq": ["takje", "takjes"] }
    } },

  { "unitKey": "hdfl", "translated": false,
    "values": {
      "en": { "unitName": "handful", "eq": ["handful", "handfuls"] },
      "fr": { "unitName": "poignée", "eq": ["poignée", "poignées"] },
      "de": { "unitName": "Handvoll", "eq": ["Handvoll"] },
      "es": { "unitName": "puñado", "eq": ["puñado", "puñados"] },
      "nl": { "unitName": "handvol", "eq": ["handvol"] }
    } },

  { "unitKey": "stk", "translated": false,
    "values": {
      "en": { "unitName": "stick", "eq": ["stick", "sticks"] },
      "fr": { "unitName": "bâton", "eq": ["bâton", "bâtons"] },
      "de": { "unitName": "Stange", "eq": ["Stange", "Stangen"] },
      "es": { "unitName": "barra", "eq": ["barra", "barras"] },
      "nl": { "unitName": "stengel", "eq": ["stengel", "stengels"] }
    } },

  { "unitKey": "drop", "translated": false,
    "values": {
      "en": { "unitName": "drop", "eq": ["drop", "drops"] },
      "fr": { "unitName": "goutte", "eq": ["goutte", "gouttes"] },
      "de": { "unitName": "Tropfen", "eq": ["Tropfen"] },
      "es": { "unitName": "gota", "eq": ["gota", "gotas"] },
      "nl": { "unitName": "druppel", "eq": ["druppel", "druppels"] }
    } },

  { "unitKey": "scp", "translated": false,
    "values": {
      "en": { "unitName": "scoop", "eq": ["scoop", "scoops"] },
      "fr": { "unitName": "boule", "eq": ["boule", "boules"] },
      "de": { "unitName": "Kugel", "eq": ["Kugel", "Kugeln"] },
      "es": { "unitName": "bola", "eq": ["bola", "bolas"] },
      "nl": { "unitName": "bol", "eq": ["bol", "bollen"] }
    } }
]
